<template>
    <div class="new-task-comp">
        <how-to-set-task-time></how-to-set-task-time>
        <how-to-set-task-bonus></how-to-set-task-bonus>
        <how-to-set-tasker></how-to-set-tasker>
        <modal class="house-list" :display="modalStatus.houseList" @modalStatus="closeModal()" >
            <h1>
                選擇房源
                <word-tips-hover data="上架狀態的房源、未建立委託的房源才可以新增委託" width="360px"></word-tips-hover>
            </h1>
            <div class="content">
                <div class="table-title">
                    <span class="name">房源名稱</span>
                    <span class="rent">租金</span>
                    <span class="address">房源地址</span>
                </div>
                <div class="table-body">
                    <ul :key="'height'+componentKey" v-bind:style="{'height': modalHeight}">
                        <li v-for="(item, index) in houseList" :key="index">
                            <default-radio v-model="selectedHouseInfo.seletedNum" :isPropChecked="false" :val="index"></default-radio>
                            <span class="name">{{item.houseName}}</span>
                            <span class="rent">{{item.rentMonthly}}</span>
                            <span class="address">{{item.address}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button" @click="setHouseInfo(), closeModal()">確認</button>
            </div>
        </modal>
        <pay-atm-detail :taskId="taskId" :taskSeq="taskSeq"></pay-atm-detail>
        <pay-wallet-detail :walletPaymentInfo="walletPaymentInfo"></pay-wallet-detail>
        <alart-msg :display="alart.success" styleType="success" @alartStatus="alart.success = false">
            <span class="title" slot="title">{{msg.success}}</span>
        </alart-msg>
        <alart-msg :display="alart.fail" styleType="error" @alartStatus="alart.fail = false">
            <span class="title" slot="title">{{msg.error}}</span>
        </alart-msg>
        <!-- <div class="task-state">
            <div class="task-state-wrap">
                <span class="progress">
                    <span class="progress-bar">
                        <span class="progress-landlord" :class="{'active': taskState == 1 || taskState == 2}">
                            <img v-if="taskState == 1 || taskState == 2" src="@/assets/img/icon/radio_blue.svg" alt="">
                            <img v-else src="@/assets/img/icon/radio_gray.svg" alt="">
                            填寫資料
                        </span>
                        <span class="progress-hr" :class="{'active': taskState == 2}"></span>
                        <span class="progress-tanant" :class="{'active': taskState == 2}">
                            <img v-if="taskState == 2" src="@/assets/img/icon/radio_blue.svg" alt="">
                            <img v-else src="@/assets/img/icon/radio_gray.svg" alt="">
                            支付獎金
                        </span>
                    </span>
                </span>
            </div>
            <div class="btn-group">
                <router-link :to="{ name: 'TaskManagementdefault'}" @click="$analytics.logEvent('委託房客_回到委託首頁', { screen_name: '委託房客_回到委託首頁'})">
                    <button v-if="taskState == 2" class="level3-btn view-new-task" >回到委託首頁</button>
                </router-link> 
                <router-link :to="{ name: 'TaskManagementdefault'}">
                    <button v-if="taskState == 1" class="border-button save" >取消</button>
                </router-link>
                <button v-if="taskState == 1" :disabled="disabledState" @click="setTask(), $analytics.logEvent('下一步：支付獎金', { screen_name: '下一步：支付獎金'})" class="default-button next" >下一步：支付獎金</button>
            </div>
        </div>-->
        <div class="block">
            <div class="block-title">
                受託人確認
            </div>
            <div class="block-wrap">
                <div class="task-house">
                    <label for="">
                        選擇房源
                        <span v-show="error.houseErr" class="error">{{error.houseErr}}</span>
                    </label>
                    <div class="input-error-group">
                        <div v-if="selectedHouseInfo.houseName" class="house-info-wrap">
                            <default-radio :isPropChecked="true"></default-radio>
                            <div class="house-info">
                                <div class="name">{{selectedHouseInfo.houseName}}</div>
                                <div class="address">{{selectedHouseInfo.address}}</div>
                                <div class="rent">租金：${{selectedHouseInfo.rent}}</div>
                            </div>
                            <button v-if="!this.$route.query.hid" class="border-button" @click="choseHouse(), $analytics.logEvent('選擇房源', { screen_name: '選擇房源'})">選擇房源</button>
                        </div>
                        <button v-else class="border-button" @click="choseHouse(), $analytics.logEvent('選擇房源', { screen_name: '選擇房源'})">選擇房源</button>
                        <div v-if="newTask.houseCid" class="tasker-info-wrap">
                            <div v-if="hasTaker" class="tasker-info">
                                <div class="name">
                                    受託人 ( 房客 ) 姓名：{{newTask.name}}
                                </div>
                                <div class="phone">
                                    受託人 ( 房客 ) 電話：{{newTask.taskTakerPhone}}
                                </div>
                            </div>
                            <div v-else class="tasker-check">
                                <div class="task-phone">
                                    <label for="">
                                        受託人電話
                                        <span v-show="error.phoneErr" class="error">{{error.phoneErr}}</span>
                                    </label>
                                    <div class="input-error-group">
                                        <input type="text" :class="{confirm: newTask.phone, error: error.phoneErr}" v-model="newTask.taskTakerPhone" placeholder="請輸入受託人電話">
                                    </div>
                                    <div class="manual" @click="openHowToSetTasker()">
                                        受託人資料？
                                    </div>
                                </div>
                                <div v-if="newTask.name && error.phoneErr == null" class="name">
                                    受託人姓名：{{newTask.name}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="block">
            <div class="block-title">委託設定</div>
            <div class="block-wrap task-setting">
                <!-- <div class="task-phone">
                    <label for="">
                        代理人電話
                        <span v-show="error.phoneErr" class="error">{{error.phoneErr}}</span>
                    </label>
                    <div class="input-error-group">
                        <input :disabled="disabledInput" type="text" :class="{confirm: newTask.name, error: error.phoneErr}" v-model="newTask.taskTakerPhone" placeholder="請輸入代理人電話">
                        <button class="border-button" @click="getTaker(), $analytics.logEvent('檢查代理人電話', { screen_name: '檢查代理人電話'})">檢查</button>
                    </div>
                </div>
                <div class="task-name">
                    <label for="">
                        代理人姓名
                        <span v-show="error.nameErr" class="error">{{error.nameErr}}</span>
                    </label>
                    <div class="input-error-group">
                        <input :disabled="disabledInput" type="text" :class="{confirm: newTask.name, error: error.nameErr}" v-model="newTask.name" placeholder="請輸入真實姓名">
                    </div>
                </div> -->
                <div class="task-bonus">
                    <label for="">
                        委託獎金
                        <span v-show="error.bonusErr" class="error">{{error.bonusErr}}</span>
                    </label>
                    <div class="input-error-group">
                        <input type="text" :class="{confirm: newTask.bonus, error: error.bonusErr}" v-model="newTask.bonus" placeholder="最低為一個月租金的20%">
                    </div>
                    <div class="manual" @click="openHowToSetTaskBonus()">
                        不知道如何設定委託獎金？
                    </div>
                </div>
                <div class="task-start">
                    <label for="">
                        委託開始時間
                        <span v-show="error.taskBeginTimeErr" class="error">{{error.taskBeginTimeErr}}</span>
                    </label>
                    <div class="input-error-group">
                        <date-picker v-model="newTask.taskBeginTime" :class="{'active': newTask.taskBeginTime != null, error: error.taskBeginTimeErr}" placeholder="請選擇日期" :disabled-date="notBeforeThisday" format="YYYY.MM.DD" value-type="YYYY/MM/DD"></date-picker>
                    </div>
                    <div class="manual" @click="openHowToSetTaskTime()">
                        不知道如何設定委託時間？
                    </div>
                </div>
                <div class="task-end">
                    <label for="">
                        委託結束時間
                        <span v-show="error.taskEndTimeErr" class="error">{{error.taskEndTimeErr}}</span>
                    </label>
                    <div class="input-error-group">
                        <date-picker :key="componentKey+'taskEndDate'" v-model="newTask.taskEndTime" :class="{'active': newTask.taskEndTime != null, error: error.taskEndTimeErr}" placeholder="請選擇日期" :disabled-date="notBeforeTaskBeginDay" format="YYYY.MM.DD" value-type="YYYY/MM/DD"></date-picker>
                    </div>
                    <div class="manual" @click="openHowToSetTaskTime()">
                        不知道如何設定委託時間？
                    </div>
                </div>
            </div>
        </div>
        <div class="block">
            <div class="block-title">委託說明</div>
            <div class="block-wrap">
                <ul>
                    <li>1. 進行委託前建議先行與受託人溝通，明確說明委託的獎金以及委託規則。</li>
                    <li>2. 提醒受託人在帶看房源時，須請看屋人下載飛豬APP並且掃描看屋人QRcode，做為日後委託達成，獎金發放依據。</li>
                    <li>3. 委託開始進行之後，無論最後委託成功或失敗均須支付平台服務費，費用為委託獎金的20%。</li>
                    <div class="check-box-group">
                        <rent-checkbox :class="{'check-err': error.checkBoxErr}" v-model="newTask.isRead" val="1" checkboxMsg="已閱讀說明並同意" tickColor="black" bgColor="#fff" borderColor="#cacfcd" :isPropChecked="false" ></rent-checkbox>
                        <span v-if="error.checkBoxErr" class="check-box-error">
                            尚未閱讀並同意委託說明
                        </span>
                    </div>
                </ul>
            </div>
        </div>
        <div class="block">
            <div class="block-title">支付獎金</div>
            <div class="block-wrap virtual">
                <div class="pay-types">
                    <div class="type atm" :class="{'active': payType==0}" @click="payType=0, balanceNotEnough = ''">
                        <img v-if="payType==0" src="@/assets/img/icon/atm_orange.svg" alt="" srcset="">
                        <img v-else src="@/assets/img/icon/atm_gray.svg" alt="" srcset="">
                        <div class="content-wrap">
                            <div class="title">
                                匯款帳號
                            </div>
                        </div>
                    </div>
                    <div class="type wallet" :class="{'active': payType==1}" @click="checkBalance()">
                        <img v-if="payType==1" src="@/assets/img/icon/wallet_orange.svg" alt="" srcset="">
                        <img v-else src="@/assets/img/icon/wallet_gray.svg" alt="" srcset="">
                        <div class="content-wrap">
                            <div class="title">
                                飛豬錢包
                            </div>
                            <div class="description">
                                錢包餘額：{{toCurrency(userBalance)}}
                            </div>
                        </div>
                        <span class="balance-not-enough" v-if="balanceNotEnough">
                            <img src="../../../assets/img/icon/alarm_msg_error.svg" alt="">
                            {{balanceNotEnough}}
                        </span>
                    </div>
                </div>
                <div v-if="payType!=null" class="confirm-info">
                    <h2>確認資訊</h2>
                    <div class="content">
                        <div class="list">
                            <span class="title">付款方式</span>
                            <span class="info">：{{payTypeInfo[payType].type}}</span>
                        </div>
                        <div class="list">
                            <span class="title">扣款項目</span>
                            <span class="info">：委託獎金</span>
                        </div>
                        <div class="list">
                            <span class="title">扣款金額</span>
                            <span class="info" :class="{'warm': !newTask.bonus}">：{{newTask.bonus?toCurrency(newTask.bonus):'尚未輸入委託獎金'}}</span>
                        </div>
                        <div class="list">
                            <span class="title">金額幣別</span>
                            <span class="info">：TWD</span>
                        </div>
                    </div>
                    <button class="default-button" :disabled="disabledState" @click="payEvent()">確定使用{{payTypeInfo[payType].type}}付款</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Breadcrumb from '@/components/widge/Breadcrumb.vue';
import RentSelectHouse from '@/components/widge/RentSelectHouse.vue';
import DatePicker from 'vue2-datepicker';
import RentCheckbox from '@/components/widge/RentCheckbox.vue';
import DefaultRadio from '@/components/widge/DefaultRadio.vue';
import Modal from '@/components/widge/Modal.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import payAtmDetail from '@/components/widge/modal/payAtmDetail.vue';
import payWalletDetail from '@/components/widge/modal/payWalletDetail.vue';
import howToSetTaskTime from '@/components/widge/modal/howToSetTaskTime.vue';
import howToSetTaskBonus from '@/components/widge/modal/howToSetTaskBonus.vue';
import howToSetTasker from '@/components/widge/modal/howToSetTasker.vue';
import wordTipsHover from '@/components/bussiness/widges/tips/wordTipsHover.vue';
import { mapGetters } from 'vuex'
import { 
    getHouseDetail
} from "@/apis/company/houseMgt.js"; 
import { 
    apiGetTasker,
    apiSetTask,
    apiGetTaskHouse,
    apiGetContractTenant,
    apiGetContractHouse
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            modalHeight: (window.innerHeight-300) + 'px',
            componentKey: 0,
            isDefault: false,
            taskState: 1,
            payType: null,
            hasTaker: false,
            payTypeInfo:[
                {
                    type: '匯款轉帳'
                },
                {
                    type: '飛豬錢包'
                }
            ],
            taskId: null,
            taskSeq: null,
            walletPaymentInfo: {},
            selectHouse: null,
            houseList: [],
            disabledState: true,
            disabledInput: false,
            balanceNotEnough: '',
            selectedHouseInfo: {
                seletedNum: null,
                houseName: null,
                rent: 0,
                address: null
            },
            virtualAccountDetail: {},
            newTask: {
                "houseCid": null,
                "contractEndTime": null,
                "taskTakerPhone": null, 
                "name": null,
                "bonus": null,
                "taskBeginTime": null,
                "taskEndTime": null,
                "isRead": false
            },
            error: {
                houseErr: null,
                phoneErr: null,
                nameErr: null,
                bonusErr: null,
                taskBeginTimeErr: null,
                taskEndTimeErr: null,
                checkBoxErr: null
            },
            modalStatus: {
                houseList: false
            },
            alart: {
                success: false,
                fail: false
            },
            msg: {
                success: null,
                error: null,
            },
            totalPage: 0
        }
    },
    mounted () {
        this.$analytics.logEvent('新增委託', { screen_name: '新增委託'})
        // console.log(this.$route.query.hid)
        if(this.$route.query.hid){
            this.getHouseInfo(this.$route.query.hid)
        }else{
            this.getHouseList(1)
        }
        this.$store.dispatch('getUserBalance')
        window.addEventListener('resize', this.resizeModal)
    },
    destroyed() {
        window.removeEventListener('resize', this.resizeModal)
    },
    watch: {
        newTask:{
            handler: function (val) {
                let numerical = /^[0-9]*$/;
                this.componentKey += 1
                
                if( val.bonus){
                    this.balanceNotEnough = null
                    if(this.payType==1){
                        this.checkBalance()
                    }
                    if (!numerical.test(val.bonus)) {
                        this.error.bonusErr = '請填寫數字'
                    }
                    else{
                        this.error.bonusErr = null
                    }
                }
                if(val.houseCid && val.taskTakerPhone && this.error.phoneErr == null && this.error.bonusErr == null && val.taskBeginTime && val.taskEndTime && val.isRead){
                    this.disabledState = false
                }else{
                    this.disabledState = true
                }
            },
            deep: true
        },
        'newTask.taskTakerPhone':{
            handler: function (val){
                let phoneReg = /^09[0-9]{8}$/;

                if( val ){
                    if (!phoneReg.test(val)) {
                        this.error.phoneErr = '格式不符'
                    }
                    else{
                        if(!this.hasTaker){
                            this.getTaker()
                            this.error.phoneErr = null
                            this.newTask.name = null
                        }
                    }
                }else{
                    this.newTask.name = null
                    this.error.phoneErr = null
                }

            }
        },
        'newTask.taskBeginTime':{
            handler: function (val){
                this.error.taskEndTimeErr = null
                var days = parseInt(Math.abs(this.newTask.taskEndTime - this.newTask.taskBeginTime ) / 1000 / 60 / 60 / 24); // 把相差的毫秒數轉換為天數
                console.log(days)
                if(days > 62){
                    this.newTask.taskEndTime = null
                }
                // let number = 0
                // let startDate = this.newTask.taskBeginTime
                // let endDate = this.newTask.taskEndTime
                // let yearToMonth = (endDate.getFullYear() - startDate.getFullYear()) * 12;
                // number += yearToMonth;
                // let monthToMonth = endDate.getMonth() - startDate.getMonth();  
                // number += monthToMonth; 
                // console.log(number)
            }
        },
        totalPage: function (page) {
            // console.log(page)
            if(page > 1){
                for (let i = 2; i <= page; i++) {
                    this.getHouseList(i)
                }
            }
        }
    },
    methods: {
        resizeModal: function (){
            let _self = this
            console.log(window.innerHeight)
            if( window.innerHeight > 610){
                _self.modalHeight = (window.innerHeight-300) + 'px'
                _self.componentKey += 1
            }
        },
        choseHouse: function () {
            this.newTask.taskBeginTime = null
            this.newTask.taskEndTime = null
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
            this.modalStatus.houseList = true
        },
        openHowToSetTaskBonus: function () {
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
            this.$store.dispatch('setModalStatus', {state: true, type: 'howToSetTaskBonus'})
            this.$analytics.logEvent('不知道如何設定委託獎金', { screen_name: '不知道如何設定委託獎金'})
        },
        openHowToSetTaskTime: function () {
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
            this.$store.dispatch('setModalStatus', {state: true, type: 'howToSetTaskTime'})
            this.$analytics.logEvent('不知道如何設定委託時間', { screen_name: '不知道如何設定委託時間'})
        },
        openHowToSetTasker: function () {
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
            this.$store.dispatch('setModalStatus', {state: true, type: 'howToSetTasker'})
            this.$analytics.logEvent('受託人資料', { screen_name: '受託人資料'})
        },
        closeModal: function () {
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '8'
            this.modalStatus.houseList = false
        },
        getSelectId: function (value) {
            if( value.ref == 'house' ){
                this.newTask.houseCid = value.id
            }
        },
        selectHouseName: function (index) {
            return this.$refs.houseItem[index].children[0].innerText
        },
        notBeforeThisday(date) {
            
            let today = new Date();
            today.setHours(0, 0, 0, 0);

            let contractEndTime = new Date(this.newTask.contractEndTime)
            contractEndTime.setMonth(contractEndTime.getMonth() - 2);
            console.log(contractEndTime)
            return date < contractEndTime || date < today;
        },
        notBeforeTaskBeginDay(date) {
            var d = new Date(this.newTask.taskBeginTime);
            d.setMonth(d.getMonth() + 2);
            let contractEndTime = new Date(this.newTask.contractEndTime)
            let taskBeginTime = new Date(this.newTask.taskBeginTime)
            return date < contractEndTime || date > d || date < taskBeginTime;
        },
        checkBalance: function () {
            if(this.newTask.bonus == null){
                this.payType = 1
            }else if(parseFloat(this.userBalance) >= parseFloat(this.newTask.bonus)){
                this.balanceNotEnough = ''
                this.payType = 1
            }else{
                this.balanceNotEnough = '餘額不足'
                this.payType = null
            }
        },
        payEvent: function () {
            this.setTask()
            .then(() => {
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
                if(this.payType==0){
                    this.$analytics.logEvent('帳號匯款', { screen_name: '帳號匯款'})
                    this.balanceNotEnough = ''
                    this.$store.dispatch('setModalStatus', {state: true, type: 'payAtmDetail'})
                    this.disabledState = false
                }else if(this.payType==1){

                        let data = {
                            paymentType: 'HOUSE_TASK_BONUS',
                            referenceSeq: this.taskSeq
                        }
                        this.$store.dispatch('walletPayment', data)
                        .then((res)=>{
                            this.$analytics.logEvent('飛豬錢包付款', { screen_name: '飛豬錢包付款'})
                            this.walletPaymentInfo = res
                            this.$store.dispatch('setModalStatus', {state: true, type: 'payWalletDetail'})
                            this.disabledState = false
                        })
                        .catch(() => {
                            this.alart.fail = true
                            this.msg.error = '飛豬錢包扣款失敗'
                            this.disabledState = false
                        })
                }
            })
            
        },
        setTask: function () {
            return new Promise((resolve, reject) => {
                let data =  {
                    "houseCid": parseInt(this.newTask.houseCid),
                    "taskTakerPhone": this.newTask.taskTakerPhone, 
                    "bonus": parseInt(this.newTask.bonus),
                    "taskBeginTime": this.newTask.taskBeginTime,
                    "taskEndTime": this.newTask.taskEndTime,
                }
                this.disabledState = true
                // console.log(data)
                apiSetTask(data)
                .then( res => {
                    console.log(res)
                    if(res.data.status == 'SUCCESS'){
                        this.taskId = res.data.result.taskCid
                        this.taskSeq = res.data.result.taskSeq
                        resolve()
                    }else{
                        this.disabledState = false
                        this.alart.fail = true
                        this.msg.error = res.data.errorMsg
                        if(res.data.errorCode == 244003){
                            this.error.bonusErr = res.data.errorMsg
                        }else if(res.data.errorCode == 244001){
                            this.error.phoneErr = res.data.errorMsg
                        }else if(res.data.errorCode == 244002){
                            this.error.houseErr = res.data.errorMsg
                        }else if(res.data.errorCode == 244005){
                            this.error.taskBeginTimeErr = res.data.errorMsg
                            this.error.taskEndTimeErr = res.data.errorMsg
                        }else if(res.data.errorCode == 231010){
                            this.error.houseErr = res.data.errorMsg
                        }else if(res.data.errorCode == 244009){
                            this.error.houseErr = res.data.errorMsg
                        }else if(res.data.errorCode == 244004){
                            this.error.phoneErr = res.data.errorMsg
                        }
                        
                    }
                }).catch( err => {
                    console.log(err)
                })
            })
        },
        getHouseList: function (page) {
            apiGetTaskHouse(page)
            .then( res => {
                console.log('getHouseList', res)
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.totalPage = res.data.result.totalPage
                    res.data.result.houseForTaskDtoList.map( item => {
                        this.houseList.push(item) 
                    })
                }
            }).catch( err => {
                console.log(err)
            })
        },
        getHouseInfo: function (hid) {
            const data = {
                houseCid: hid,
                isLandlordWeb: true
            }
            getHouseDetail(data)
            .then( res => {
                console.log('getHouseInfo',res)
                if(res.data.status = 'SUCCESS'){
                    let contractCid = res.data.result.houseDetail.contractCid
                    if(contractCid){
                        this.getContractDetail(contractCid)
                        .then( () => {
                            this.getContractTenant(contractCid)
                            .then( tenant => {
                                // console.log(tenant)
                                let obj = {
                                    houseName: res.data.result.houseDetail.name,
                                    rentPrice: res.data.result.houseDetail.rentMonthly,
                                    address: res.data.result.houseDetail.address,
                                    tenantName: tenant.tenantName,
                                    tenantPhone: tenant.tenantPhone
                                }
                                this.setHouseInfo(obj)

                            })
                        })
                        
                    }else{
                        let obj = {
                            houseName: res.data.result.houseDetail.name,
                            rentPrice: res.data.result.houseDetail.rentMonthly,
                            address: res.data.result.houseDetail.address,
                        }
                        this.setHouseInfo(obj)

                    }
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        getContractDetail: function (contractCid){
            return new Promise((resolve, reject) => {
                let data = contractCid
                apiGetContractHouse(data)
                .then(res => {
                    if( res.data.status == "SUCCESS" ){
                        console.log('getContractDetail',res)

                        
                        this.newTask.contractEndTime = res.data.result.contractEndTime - 28800000

                        let taskBeginTimeRefToday = new Date()
                        let taskEndTimeRefToday = new Date()

                        let taskBeginTime = new Date(this.newTask.contractEndTime)
                        let taskEndTimeReftaskBeginTime = new Date(this.newTask.contractEndTime)

                        taskEndTimeRefToday.setMonth(taskEndTimeRefToday.getMonth() + 2);
                        taskBeginTime.setMonth(taskBeginTime.getMonth() - 2);
                        taskEndTimeReftaskBeginTime.setMonth(taskEndTimeReftaskBeginTime.getMonth())
                      
                        if(taskBeginTime<taskBeginTimeRefToday){
                            this.newTask.taskEndTime = taskEndTimeRefToday
                            this.newTask.taskBeginTime = taskBeginTimeRefToday

                        }else{
                            this.newTask.taskEndTime = taskEndTimeReftaskBeginTime
                            this.newTask.taskBeginTime = taskBeginTime
                        }

                        resolve()

                    }
                })
                .catch(err => {
                    console.log(err)
                })
            })
        },
        getContractTenant: function (contractCid) {
            return new Promise((resolve, reject) => {
                let data = contractCid
                apiGetContractTenant(data)
                .then(res => {
                    console.log(res)
                    if( res.data.status == "SUCCESS" ){
                        // console.log(res)
                        let tenantName = res.data.result.tenantName
                        let tenantPhone= res.data.result.phoneNumber
                        resolve({tenantName, tenantPhone})
                    }else{
                        this.alart.fail = true
                        this.msg.error = res.data.errorMsg
                    }
                })
                .catch(err => {
                    console.log(err)
                })
            })
            
        },
        setHouseInfo: function (data) {
            if(data){
                this.selectedHouseInfo.houseName = data.houseName
                this.selectedHouseInfo.rent = data.rentPrice
                this.selectedHouseInfo.address = data.address
                if( data.tenantPhone && data.tenantName){
                    this.hasTaker = true
                    this.disabledInput = true
                    this.newTask.taskTakerPhone = data.tenantPhone
                    this.newTask.name = data.tenantName
                }else{
                    this.hasTaker = false
                    this.disabledInput = false
                    this.newTask.taskTakerPhone = null
                    this.newTask.name = null
                }
                this.newTask.houseCid = this.$route.query.hid
            }else{
                let house = this.houseList[this.selectedHouseInfo.seletedNum]
                console.log(house)
                if(house.contractCid){
                    this.getContractDetail(house.contractCid)
                }
                this.selectedHouseInfo.houseName = house.houseName
                this.selectedHouseInfo.rent = house.rentMonthly
                this.selectedHouseInfo.address = house.address
                this.newTask.houseCid = house.houseCid
                if( house.tenantInfo && house.tenantInfo.phoneNumber){
                    this.hasTaker = true
                    this.disabledInput = true
                    this.newTask.taskTakerPhone = house.tenantInfo.phoneNumber
                    this.newTask.name = house.tenantInfo.tenantName
                }else{
                    this.hasTaker = false
                    this.disabledInput = false
                    this.newTask.taskTakerPhone = null
                    this.newTask.name = null
                }
            }
        },
        getTaker: function () {
            let data = this.newTask.taskTakerPhone
            apiGetTasker(data)
            .then( res => {
                console.log(res)
                if(res.data.status == 'SUCCESS'){
                    this.newTask.name = res.data.result.name
                }else{
                    this.alart.fail = true
                    this.msg.error = res.data.errorMsg
                }
            }).catch( err => {
                console.log(err)
            })
        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
        },
        getExpiredFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            formatDate[5] = (Array(2).join(0)+date.getSeconds()).slice(-2);
            //月及天兩位數
            formatDate[6] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[7] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            // if(formatDate[3] - 8 < 0){
            //     formatDate[3] = 24+(formatDate[3]-8);
            //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            // }else{
            //     formatDate[3] = formatDate[3]-8;
            //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            // }
            return formatDate[0]+'-'+formatDate[6]+'-'+formatDate[7]+' '+formatDate[3]+':'+formatDate[4]+':'+formatDate[5];
        },
        // toCurrency: function (num){
        //     if(num){
        //         var parts = num.toString().split('.');
        //         // console.log(parts);
        //         parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //         return parts.join('.');
        //     }
        // },
    },
    computed: {
        filterHouse: function () {
            if(this.houseList.filter.length > 0){
                return this.houseList.filter((house) => {
                    if( this.selectHouse ){
                        if(house.address.includes(this.selectHouse) || house.houseName.includes(this.selectHouse) ){
                            return house
                        }
                    }else{
                        return house
                    }
                });
            }
        },
        ...mapGetters({
            userBalance: 'GET_USER_BALANCE',
        })
    },
    components: {
        Breadcrumb,
        DatePicker,
        RentSelectHouse,
        RentCheckbox,
        Modal,
        DefaultRadio,
        AlartMsg,
        payAtmDetail,
        payWalletDetail,
        howToSetTaskTime,
        howToSetTaskBonus,
        howToSetTasker,
        wordTipsHover
    }
}
</script>
<style lang="scss" scoped>
    .new-task-comp{
        padding-bottom: 194px;
        span.error{
            position: relative;
            bottom: unset;
            left: unset;
        }
        #modal.house-list{
            .modal-content{
                width: 794px;
                padding: 0 !important;
                .detail{
                    align-items: flex-start !important;
                    h1{
                        display: flex;
                        font-size: 24px;
                        margin: auto;
                        margin-top: 32px;
                        margin-bottom: 32px;
                    }
                    .content{
                        width: 735px;
                        color: #a8a5a4;
                        margin-bottom: 8px;
                        padding: 0px 32px;
                        .table-title{
                            padding: 20px 0;
                            border-top: 1px solid #F1F5F4;
                            border-bottom: 1px solid #F1F5F4;
                            display: flex;
                            align-items: center;
                            .name{
                                width: 200px;
                                margin-left: 71px;
                                margin-right: 60px;
                            }
                            .rent{
                                width: 62px;
                                margin-right: 40px;
                            }
                        }
                        .table-body{
                            ul{
                                height: 360px;
                                overflow-x: hidden;
                                &::-webkit-scrollbar {
                                    display: none;
                                }
                                li{
                                    display: flex;
                                    align-items: center;
                                    padding: 20px 0;
                                    border-bottom: 1px solid #F1F5F4;
                                    .name{
                                        width: 200px;
                                        margin-left: 40px;
                                        margin-right: 60px;
                                    }
                                    .rent{
                                        width: 62px;
                                        margin-right: 40px;
                                    }
                                }
                            }
                            ul::-webkit-scrollbar {
                                display: none;
                            }
                        }
                    }
                    .btn-group{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        height: 84px;
                        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                        border-radius:  0 0 20px 20px;
                        margin: 0 auto;
                        button{
                            width: 184px;
                            height: 44px;
                        }
                    }
                }
            }
        }
        .task-state{
            position: relative;
            display: flex;
            align-items: center;
            width: 1106px;
            height: 44px;
            padding: 14px 24px;
            border-radius: 10px;
            box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
            background-color: #ffffff;
            margin-bottom: 60px;
            .progress-bar{
                display: flex;
                align-items: center;
                .progress-landlord,
                .progress-tanant,
                .progress-desposit{
                    display: flex;
                    align-items: center;
                    font-size: 12px;
                    color: #a8a5a4;
                    img{
                        margin-right: 8px;
                    }
                }
                .progress-landlord.active,
                .progress-tanant.active,
                .progress-desposit.active{
                    color: #71aae5;
                }
                .progress-landlord,
                .progress-tanant{
                    width: 72px;
                }
                .progress-desposit{
                    width: 85px;
                }
                .progress-hr{
                    width: 208px;
                    height: 1px;
                    background: #cacfcd;
                    margin: 0 16px;
                }
                // .progress-hr.active{
                //     background: #f5a623;
                // }
            }
            .btn-group{
                position: absolute;
                right: 24px;
                .save{
                    width: 132px;
                    margin-right: 12px;
                }
                .next{
                    width: 200px;
                }
                .view-new-task{
                    width: 200px;
                    height: 44px;
                    cursor: pointer;
                }
            }
        }
        .manual{
            color: #3942b5;
            font-size: 12px;
            margin-top: 8px;
            cursor: pointer;
        }
        .block{
            margin-bottom: 30px;
            width: 1154px;
            label{
                position: relative;
                margin-bottom: 12px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-weight: 500;
            }
            .block-title{
                display: flex;
                align-items: center;
                font-size: 20px;
                margin-bottom: 30px;
                color: #ff9275
            }
            .block-wrap{
                position: relative;
                display: flex;
                flex-wrap: wrap;
                border: solid 1px #f0f0f0;
                background-color: #ffffff;
                padding: 24px;
                border-radius: 8px;
                .check-box-group{
                    display: flex;
                    align-items: center;
                    label{
                        margin-bottom: 0px;
                        margin-right: 8px;
                    }
                    .check-box-error{
                        color: #fc7171;
                    }
                    .check-err{
                        span{
                            border: 1px solid  #fc7171 !important;
                        }
                    }
                }
                input{
                    height: 44px;
                }
                .task-house{
                    .input-error-group{
                        >button{
                            width: 308px;
                            height: 44px;
                        }
                        .house-info-wrap{
                            position: relative;
                            display: flex;
                            align-items: center;
                            width: 1058px;
                            height: 72px;
                            border-radius: 4px;
                            border: solid 1px #ff9275;
                            background: #fff;
                            padding: 16px 24px 16px 24px;
                            .house-info{
                                margin-left: 22px;
                                >div{
                                    margin-bottom: 6px;
                                }
                            }
                            >button{
                                position: absolute;
                                right: 24px;
                                width: 200px;
                                height: 44px;
                                background-color: #fff9f1;
                                border: none;
                            }
                        }
                        .tasker-info{
                            width: 1066px;
                            padding: 20px;
                            background-color: #f6f6f6;
                            border-radius: 4px;
                            margin-top: 12px;
                            .name{
                                margin-bottom: 8px;
                            }
                        }
                        .tasker-check{
                            width: 1116px;
                            display: flex;
                            align-items: flex-start;
                            justify-content: space-between;
                            .task-phone{
                                margin-top: 12px;
                                input{
                                    width: 182px;
                                    margin-right: 12px;
                                }
                                button{
                                    width: 76px;
                                    box-sizing: border-box;
                                }
                            }
                            .name{
                                position: relative;
                                top: 40px;
                                width: 100%;
                                padding: 15px 20px;
                                border-radius: 4px;
                                background-color: #f6f6f6;
                            }
                        }
                    }
                }
                &.task-setting{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    >div{
                        // margin-bottom: 30px;
                        width: 308px;
                        input{
                            width: 100%;
                        }
                        &.task-bonus{
                            input{
                                width: 276px;
                            }
                        }
                        
                    }
                }
                .mx-datepicker{
                    width: 308px;
                    bottom: unset;
                    input{
                        width: 100%;
                        height: 44px;
                        border-radius: 4px;
                        border: solid 1px #f3f3f3;
                        color: #a8a5a4;
                        padding: 13px 16px;
                        box-shadow: none;
                        margin-bottom: 0px;
                    }
                    .mx-icon-calendar,
                    .mx-icon-clear{
                        right: 14px;
                    }
                }
                .mx-datepicker:hover,
                .mx-datepicker.active{
                    input{
                        border: 1px solid #676362 !important;
                        color: #676362 !important;
                    }
                    i{
                        color: #676362;
                    }
                }
                .mx-datepicker.error{
                    input{
                        border: solid 1px #fc7171 !important;
                    }
                }
                >ul{
                    li{
                        font-weight: 300;
                        margin-bottom: 20px;
                    }
                }
                .rent-checkbox{
                    font-weight: 300;
                }
                .atm{
                    width: 180px;
                    height: 100px;
                    border-radius: 8px;
                    border: solid 1px #676362;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 20px;
                    background: #fff;
                    img{
                        margin-right: 20px;
                    }
                }
                
            }
            .block-wrap.virtual{
                // display: flex;
                // flex-direction: column;
                .pay-types{
                    display: flex;
                    width: 1154px;
                    .type{
                        position: relative;
                        display: flex;
                        align-items: center;
                        padding: 0 20px;
                        height: 90px;
                        border-radius: 4px;
                        border: solid 1px #c5c2c1;
                        background-color: #fff;
                        line-height: 1.71;
                        color: #a8a5a4;
                        margin-right: 16px;
                        cursor: pointer;
                        img{
                            margin-right: 10px;
                        }
                        .content-wrap{
                            .description{
                                font-size: 12px;
                            }
                        }
                    }
                    .type.active{
                        border: solid 1px #ff9275;
                        background-color: #fff;
                        color: #ff9275;
                    }
                    .atm{
                        width: 121px;
                    }
                    .wallet{
                        min-width: 166px;
                        .balance-not-enough{
                            position: absolute;
                            font-size: 16px;
                            font-weight: 500;
                            color: #fc7171;
                            display: flex;
                            align-items: center;
                            bottom: -31px;
                            left: 50px;
                            img{ 
                                margin-right: 8px;
                                width: 16px;
                            }
                        }
                    }
                }
                .confirm-info{
                    width: 1094px;
                    height: 428px;
                    padding: 24px 30px;
                    border: solid 1px #f3f3f3;
                    border-radius: 8px;
                    background-color: #fff;
                    h2{
                        font-size: 20px;
                        margin-bottom: 20px;
                    }
                    .content{
                        margin-bottom: 20px;
                        .list{
                            display: flex;
                            margin-bottom: 16px;
                            .title{
                                display: block;
                                width: 56px;
                            }
                        }
                        .warm{
                            color: #fc7171;
                        }
                    }
                    .default-button{
                        width: 200px;
                    }
                }
                
            }
        }
    }
    @media screen and (max-width: 1280px) {
        .new-task-comp{
            .task-state{
                    width: 1096px;
            }
            .block{
                width: 1124px;
                .block-wrap{
                    .task-house{
                        .input-error-group{
                            .house-info-wrap{
                                width: 1024px;
                            }
                            .tasker-info-wrap{
                                width: 1024px;
                                
                            }
                            .tasker-info{
                                width: 1034px;
                            }
                        }
                    }
                }
                
               
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/taskManagement/NewTaskComp.vue